import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { ProductOfferingResponse } from '../models/product-offering-response.model';

@Injectable({
    providedIn: 'root'
})
export class ProductService {
    constructor(private http: HttpClient) {}

    getProductsOffering() {
        return this.http.get<ProductOfferingResponse[]>(`${environment.server.api.portalpas}/productoffering`);
    }
}